module.exports = __webpack_public_path__ + "img/ecb332d9454d7380f1e784851af24f03.png";